<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th colspan="2">App Config</th>
              </tr>
              <tr>
                <th>Ключ</th>
                <th>Значение</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(param, index) in appConfigArray">
                <td v-if="param[0]!='activeScenarioTemplates' && param[0]!='defaultPhonePreprocessingStrategyParameters'">
                  <input v-model="param[0]" class="input" type="text" readonly>
                </td>
                <td v-if="param[0]!='activeScenarioTemplates' && param[0]!='defaultPhonePreprocessingStrategyParameters'">
                  <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th colspan="3">Phone Preprocessing Parameters</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(param, index) in phonePreprocessingParametersArray">
                <td>
                  <input v-model="param[0]" class="input" type="text" :readonly="!canEdit()">
                </td>
                <td>
                  <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                </td>
                <td>
                  <button class="button is-light" v-on:click="deletePhonePreprocessingParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                    <span>Удалить</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td><button class="button is-light" v-on:click="addPhonePreprocessingParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                  <span>Добавить</span>
                </button></td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th colspan="2">Active Scenario Templates</th>
              </tr>
              <tr>
                <th>Scenario Template</th>
                <th>Activity</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(param, index) in activeScenarioTemplatesArray">
                <td>
                  <input v-model="param[0]" class="input" type="text" readonly>
                </td>
                <td>
                  <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <p class="control">
            <button  v-if="canEdit()" class="button is-primary" v-on:click="save(true)">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
              <span>Сохранить</span>
            </button>
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>Закрыть</span>
            </button>
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import CheckToken from '../authentication/CheckToken'

  Vue.mixin(CheckToken)

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const APPCONFIG_API = '/api/appConfig'

  export default {
    components: {
      Notification
    },
    data () {
      return {
        appConfig: {},
        appConfigArray: [
          {
            key: '',
            value: ''
          }
        ],
        activeScenarioTemplatesArray: [
          {
            key: '',
            value: ''
          }
        ],
        phonePreprocessingParametersArray: [
          {
            key: '',
            value: ''
          }
        ]
      }
    },
    created: function () {
      this.checkToken()
      this.loadConfig()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadConfig () {
        this.$http.get(APPCONFIG_API + '/dto', {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.appConfig = response.data
            this.appConfigArray = Object.entries(this.appConfig)
            this.activeScenarioTemplatesArray = []
            for (let i = 0; i < this.appConfigArray.length; i++) {
              if (this.appConfigArray[i][0] === 'activeScenarioTemplates') {
                this.activeScenarioTemplatesArray = Object.entries(Object.entries(this.appConfig)[i][1])
              }
            }
            this.phonePreprocessingParametersArray = Object.entries(this.appConfig.defaultPhonePreprocessingStrategyParameters)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
          })
      },
      save (showMessage) {
        this.appConfig = {}
        for (let i = 0; i < this.appConfigArray.length; i++) {
          let item = this.appConfigArray[i]
          this.appConfig[item[0]] = item[1]
        }
        this.appConfig.activeScenarioTemplates = {}
        for (let i = 0; i < this.activeScenarioTemplatesArray.length; i++) {
          let item = this.activeScenarioTemplatesArray[i]
          this.appConfig.activeScenarioTemplates[item[0]] = item[1]
        }
        this.appConfig.defaultPhonePreprocessingStrategyParameters = {}
        for (let i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          let item = this.phonePreprocessingParametersArray[i]
          this.appConfig.defaultPhonePreprocessingStrategyParameters[item[0]] = item[1]
        }
        this.update(showMessage)
      },
      update (showMessage) {
        console.log('updating app config: ' + JSON.stringify(this.appConfig))
        this.$http.put(APPCONFIG_API, this.appConfig, { headers: this.prepareSecurityHeader() })
          .then((response) => {
            if (showMessage) {
              this.openNotificationWithType('info', 'Параметры приложения сохранены.')
            }
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения параметров приложения. ')
        })
      },
      canEdit() {
        return true
      },
      cancel () {
        this.$router.push('/campaigns')
      },
      deletePhonePreprocessingParameter(index) {
        this.phonePreprocessingParametersArray.splice(index, 1)
      },
      addPhonePreprocessingParameter() {
        this.phonePreprocessingParametersArray.push({})
      },
      openNotificationWithType (type, message, duration) {
        openNotification({
          title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
          message: message,
          type: type,
          duration: duration
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AppConfig.vue?68117706